(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const root = document.querySelector('.product-recommendations');
    if (!root) return;
    const url = root.getAttribute('data-url');
    if (!url) return;

    const toggleShow = () => {
      const element = document.querySelector('.product-recommendations__products');
      element.setAttribute('data-show', '10');
    };

    const load = () => {
      fetch(url)
        .then((response) => response.text())
        .then((htmlText) => {
          const temp = document.createElement('div');
          temp.innerHTML = htmlText;
          const incoming = temp.querySelector('.product-recommendations');
          if (!incoming) return;

          // Replace only the inner content so styles and data-url remain
          root.innerHTML = incoming.innerHTML;

          // attach event listener to load more button
          const loadMoreButton = root.querySelector('.product-recommendations__more-link');
          if (loadMoreButton) {
            loadMoreButton.addEventListener('click', () => {
              toggleShow();
              loadMoreButton.remove();
            });
          }

          // After inserting HTML, ensure custom elements are upgraded
          if (window.customElements) {
            // Function to upgrade product cards
            const upgradeProductCards = () => {
              const productCards = root.querySelectorAll('product-card');

              productCards.forEach((card, index) => {
                // Check if the element is already properly upgraded
                if (!(card instanceof customElements.get('product-card'))) {
                  // Create a new instance and replace the old one
                  const newCard = document.createElement('product-card');
                  newCard.innerHTML = card.innerHTML;
                  // Copy all attributes
                  Array.from(card.attributes).forEach((attr) => {
                    newCard.setAttribute(attr.name, attr.value);
                  });
                  card.parentNode.replaceChild(newCard, card);
                } else {
                }
              });
            };

            // Try to upgrade immediately if already defined
            if (customElements.get('product-card')) {
              upgradeProductCards();
            } else {
              // Wait for the product-card custom element to be defined
              customElements
                .whenDefined('product-card')
                .then(() => {
                  upgradeProductCards();
                })
                .catch((error) => {
                  // Fallback: retry after a delay
                  setTimeout(() => {
                    if (customElements.get('product-card')) {
                      upgradeProductCards();
                    } else {
                    }
                  }, 1000);
                });
            }
          } else {
          }
        })
        .catch(console.error);
    };

    // Lazy-load when near viewport
    const io = new IntersectionObserver(
      (entries, obs) => {
        if (!entries[0].isIntersecting) return;
        obs.unobserve(root);
        load();
      },
      { rootMargin: '0px 0px 200px 0px' }
    );

    io.observe(root);
  })();

  } catch(e) { console.error(e); }
})();
})();
